// The renderer's URL switches a deployed build can be tuned and traced with
// from the address bar (`&tiledebug=1`, `&trace=1`, `&budget=`…), carried
// from the page URL into the gs-viewer.html iframe — SmartView does the same
// for the Scene's engine.
export const SPLAT_VIEWER_SWITCHES = [
  'tiledebug', 'flashMs', 'trace', 'budget', 'adaptBudget', 'splatFps', 'cachemb', 'pr', 'hz',
  'walk', 'run', 'wheelS', 'paceK', 'maxsplat',
] as const;

export function splatViewerSwitches(search: string): string {
  const src = new URLSearchParams(search);
  const out = new URLSearchParams();
  for (const k of SPLAT_VIEWER_SWITCHES) {
    const v = src.get(k);
    if (v) out.set(k, v);
  }
  const q = out.toString();
  return q ? `&${q}` : '';
}
